import React, { useEffect, useState } from "react";
import QRCode from "react-qr-code";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import logo from "../assets/images/ozoro.png";
import moment from "moment";
import { getHostelList, hostelError, isHostelPaymentConfirmed } from "../utils/hostel";
import avatar from "../assets/images/random-avatar1.jpg"
import useDetails from "../hooks/useDetails";
import { currencyFormatter, InstitutionName } from "../utils";

function HostelInvoice() {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [searchParams] = useSearchParams();
    const receiptReference = searchParams.get("reference");
    const [reference, setReference] = useState()
    const [amount, setAmount] = useState()
    const [createdAt, setCreatedAt] = useState()
    const [general, setGeneral] = useState()
    const navigate = useNavigate();

    const {data} = useDetails()
    const photo = data?.photo
  
    const { state } = useLocation();
  
    const printPaymentReceipt = () => {
      window.print();
    };
    const onImageError = (e) => {
      e.target.src = avatar
    }
  
  
    useEffect(() => {
      let active = true;
      const load = async () => {
        setLoading(true);
        setError("");
        try {
          // Reload authoritative payment data; navigation state only supplies the reference.
          const ref = receiptReference || state?.invoice?.transaction_ref;
          if (!ref) throw new Error("Open a receipt from accommodation payment history.");
          const payments = await getHostelList("/hostel/applications/payments/");
          const invoice = payments.find(payment => payment.transaction_ref === ref);
          if (!invoice || !isHostelPaymentConfirmed(invoice)) throw new Error("A confirmed payment receipt was not found.");
          if (!active) return;
          setGeneral(invoice);
          setReference(invoice.transaction_ref);
          setAmount(invoice.amount_paid);
          setCreatedAt(invoice.confirmed_at || invoice.paid_at || invoice.date_paid);
        } catch (err) {
          if (active) setError(err instanceof Error ? err.message : hostelError(err));
        } finally {
          if (active) setLoading(false);
        }
      };
      load();
      return () => { active = false; };
    }, [receiptReference, state]);


  return (
    <>
      <div className="print-button">
        <button
          onClick={() => navigate(-1)}
          className="btn-danger"
        >
          Go back
        </button>
        <button disabled={loading || !!error || !general || !data} className="btn-primary" onClick={printPaymentReceipt}>Print</button>
      </div>
      {loading && <p role="status">Loading receipt...</p>}
      {error && <p role="alert">{error} <button onClick={() => navigate("/accommodation/history")}>Go to payment history</button></p>}
      {(data && general && !error) && (
        <div className="receipt">
          <div className="contents">
            <div className="receipt-header">
              <div className="school-title">
                <img src={logo} alt="DSP" className="logo" />
                <h3 className="name">{InstitutionName}</h3>
              </div>
              <h4 className="subheader">
                Hostel Payment Slip <span>{reference}</span>
              </h4>
            </div>
            <div className="receipt-body">
              <h4 style={{ background: "#0c0f2e" }} className="subtitle">
                Base Data
              </h4>
              <div className="body-header">
                <div className="passport">
                  <img src={photo?photo:avatar} alt="Passport" onError={onImageError}/>
                </div>
                <div className="user-details">
                  <div>
                    <h3 className="user-details-option">Name:</h3>
                    <h3 className="user-details-info">
                      {data?.surname} {data?.othername}{" "}
                    </h3>
                  </div>
                  <div>
                    <h3 className="user-details-option">Matriculation Number:</h3>
                    <h3 className="user-details-info">
                      {data?.matric_number}
                    </h3>
                  </div>
                  <div>
                    <h3 className="user-details-option">Course:</h3>
                    <h3 className="user-details-info">
                      {data?.department}
                    </h3>
                  </div>
                  <div>
                    <h3 className="user-details-option">Email:</h3>
                    <h3 className="user-details-info">
                      {data?.email}
                    </h3>
                  </div>
                  <div>
                    <h3 className="user-details-option">Entry Mode:</h3>
                    <h3 className="user-details-info">
                      {data?.entry_mode}
                    </h3>
                  </div>
                  <div>
                    <h3 className="user-details-option">Study Mode:</h3>
                    <h3 className="user-details-info">
                      {data?.study_mode}
                    </h3>
                  </div>
                  <div>
                    <h3 className="user-details-option">Session:</h3>
                    <h3 className="user-details-info">
                      {general?.session_name}
                    </h3>
                  </div>
                </div>
                <div className="qr-code">
                  {data && <QRCode value={reference} size={90} />}
                </div>
              </div>
              <h4 style={{ background: "#0c0f2e" }} className="subtitle">
                Payment Data
              </h4>

              <div className="body-info">
                <div>
                  <h3 className="user-details-option">Amount Paid:</h3>
                  <h3 className="user-details-info">{currencyFormatter(amount)}</h3>
                </div>
                <div>
                  <h3 className="user-details-option">Hostel Name:</h3>
                  <h3 className="user-details-info">{general?.hostel?.name}</h3>
                </div>
                <div>
                  <h3 className="user-details-option">Room Number:</h3>
                  <h3 className="user-details-info">{general?.room?.room_number}</h3>
                </div>
                <div>
                  <h3 className="user-details-option">Bed Space:</h3>
                  <h3 className="user-details-info">{general?.allocated_bed || "—"}</h3>
                </div>
                <div>
                  <h3 className="user-details-option">Date of Payment:</h3>
                  <h3 className="user-details-info">{createdAt ? moment(createdAt).format("DD/MM/YYYY HH:mm") : "—"}</h3>
                </div>
                <div>
                  <h3 className="user-details-option">Payment Description:</h3>
                  <h3 className="user-details-info"> Hostel Payment</h3>
                </div>
                <div>
                  <h3 className="user-details-option">Invoice ID:</h3>
                  <h3 className="user-details-info">{reference}</h3>
                </div>
                <div>
                  <h3 className="user-details-option">Payment Gateway:</h3>
                  <h3 className="user-details-info">{general?.gateway || general?.metadata?.gateway || "Online payment"}</h3>
                </div>
              </div>
            </div>
            <div className="receipt-footer">
              <p>Date: {createdAt ? moment(createdAt).format("DD/MM/YYYY HH:mm") : "—"}</p>
              <p>
                {reference} - Online Payment Slip p6389714479930 -
                Page 1 of 1
              </p>
            </div>
          </div>
        </div>
      )}
      {(!data && !loading && !error) && (
        <center>
          <div
            class="preloader pl-size-xs"
            style={{ marginRight: "5px", marginTop: "100px" }}
          >
            <div class="spinner-layer pl-red-grey">
              <div class="circle-clipper left">
                <div class="circle"></div>
              </div>
              <div class="circle-clipper right">
                <div class="circle"></div>
              </div>
            </div>
          </div>
        </center>
      )}
    </>
  )
}

export default HostelInvoice
